export { System } from './System';
export { StaticBundleResolver } from './resolver/static';

export {
  Lifecycle,
  ExportOfBundle,
  BundlesTopology,
  PickModule,
  SystemPublicState as SystemState,
  ExportOfModule,
} from './types';



// WEBPACK FOOTER //
// ./node_modules/front-system/engine/index.ts